import Vue from 'vue';
import { namespace } from 'vuex-class';
// @ts-ignore
import { AGENDA_MODULE_NAMESPACE, AGENDA_SET_APPOINTMENT_BY_FIELD } from '@/store/agenda/agenda-types.store';
import { IAppointment, AppointmentDto } from '../../../../models/appointment';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { AGENDA_SET_APPOINTMENT_BY_ID } from '../../../../store/agenda/agenda-types.store';

const AgendaStore = namespace(AGENDA_MODULE_NAMESPACE)

class AgendaViewModel extends Vue {
  /**
   *
   */
  @AgendaStore.Mutation(AGENDA_SET_APPOINTMENT_BY_FIELD)
  storeAssignValueForAppointment: <T>(payload: { [key: string]: T }) => void

  @AgendaStore.Mutation(AGENDA_SET_APPOINTMENT_BY_ID)
  storeGetAppointmentById: (payload: { id?: number, appointment: IAppointment }) => Promise<IAppointment>;

  @AgendaStore.Getter appointment: IAppointment;
  @AgendaStore.Getter originUpdatingAppointment: IAppointment;

  get typeAppointment(): string {
    return AppointmentDto.APPOINTMENT_TYPE_APPOINTMENT;
  }
  get typeEvent(): string {
    return AppointmentDto.APPOINTMENT_TYPE_EVENT;
  }
  get formmatDate(): string {
    return DateTimeHelper.dateTimeFormat;
  }
  get appointmentFkBlock(): number { return this.appointment.fk_block; }
  set appointmentFkBlock(value: number) { this.storeAssignValueForAppointment<number>({ fk_block: value }); }

  get appointmentFkTicket(): number { return this.appointment.fk_ticket; }
  set appointmentFkTicket(value: number) { this.storeAssignValueForAppointment<number>({ fk_ticket: value }); }

  get appointmentIndependentContractors(): number[] { return this.appointment.independent_contractors; }
  set appointmentIndependentContractors(value: number[]) { this.storeAssignValueForAppointment<number[]>({ independent_contractors: value }); }

  get appointmentWelcomings(): number[] { return this.appointment.welcomings; }
  set appointmentWelcomings(value: number[]) {
    console.log(value, 'value')
    this.storeAssignValueForAppointment<number[]>({ welcomings: value });
  }

  get appointmentParticipants(): number[] { return this.appointment.participants; }
  set appointmentParticipants(value: number[]) { this.storeAssignValueForAppointment<number[]>({ participants: value }); }

  get appointmentCharacterProblems(): number[] { return this.appointment.character_problems; }
  set appointmentCharacterProblems(value: number[]) { this.storeAssignValueForAppointment<number[]>({ character_problems: value }); }


  get appointmentName(): string { return this.appointment.name || ''; }
  set appointmentName(value: string) { this.storeAssignValueForAppointment<string>({ name: value }); }

  get appointmentDescription(): string { return this.appointment.description || ''; }
  set appointmentDescription(value: string) { this.storeAssignValueForAppointment<string>({ description: value }); }


  get appointmentType(): string { return this.appointment.type; }
  set appointmentType(value: string) { this.storeAssignValueForAppointment<string>({ type: value }); }

  get appointmentStartDate(): string { return this.appointment.start_date; }
  set appointmentStartDate(value: string) {
    this.storeAssignValueForAppointment<string>({ start_date: value })
  }

  get appointmentEndDate(): string { return this.appointment.end_date; }
  set appointmentEndDate(value: string) {
    this.storeAssignValueForAppointment<string>({ end_date: value });
  }

  dtTitle: string;
  constructor() {
    super();
    this.dtTitle = ''
  }
  mounted() {

  }
}
export default AgendaViewModel;


// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-modal/agenda.viewmodel.ts